export const SMETA_HISTORY_TAB = 'SMETA_HISTORY_TAB';
export const SMETA_HISTORY_DETAILS = 'SMETA_HISTORY_DETAILS';